import React from 'react';
import { SurveyFormsKPI, PositiveResponsesKPI, RegisteredReasonsKPI, ComplaintReviewKPI } from './kpis';

interface KPIsSectionProps {
  branchId?: number;
  showLoading?: boolean;
  onError?: (error: Error) => void;
  compact?: boolean;
}

const KPIsSection: React.FC<KPIsSectionProps> = ({
  branchId = 0,
  showLoading = true,
  onError,
  compact = false
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <SurveyFormsKPI
        branchId={branchId}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />

      <RegisteredReasonsKPI
        branchId={branchId}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />

      <PositiveResponsesKPI
        branchId={branchId}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />



      <ComplaintReviewKPI
        branchId={branchId}
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />
    </div>
  );
};

export default KPIsSection;